import ItemPlugin from "./LocationItem/LocationItem";
import { processRawInput, restartItemProcessing } from "./processRawInput";
import userShare from "./userShare";

export default function registerLocationPlugin() {
  return { ItemPlugin, userShare, processRawInput, restartItemProcessing };
}
